import React, { useContext } from "react"
import { Container, Box, Grid /* makeStyles */ } from "@mui/material"

import AppContext from "@secureo/common/context/AppContext/AppContext"

import SEO from "@secureo/common/components/SEO"
import { FullPageSpinner } from "components/Spinner"
// import WishlistShareDialog from "components/Dialogs/WishlistShareDialog"
// import WishlistAddAndEditDialog from "components/Dialogs/WishlistAddAndEditDialog"
import ShoppingList from "containers/ShoppingList/ShoppingList"

import { CustomAppProps } from "pages/_app"

// const useStyles = makeStyles()({
// 	buttonGrid: {
// 		display: "flex",
// 		alignItems: "center",
// 		float: "right",
// 	},
// })

const ShoppingListPage = ({ asPath }: CustomAppProps) => {
	// const {classes} = useStyles()
	const appContextState = useContext(AppContext)
	const { isInitialized } = appContextState

	if (!isInitialized) return <FullPageSpinner />

	return (
		<>
			<SEO asPath={asPath} appendLocalizedShopNameWithPipe title="Meine Wunschliste" />

			<Container>
				<Box mt={2} mb={5}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<h1 style={{ margin: 0 }}>Ihre Wunschliste(n)</h1>
						</Grid>
						{/* <Grid item xs={5}>
							<div className={classes.buttonGrid}>
								<Box mr={1} style={{ maxWidth: 230 }}>
									<WishlistShareDialog />
								</Box>
								<div style={{ maxWidth: 230 }}>
									<WishlistAddAndEditDialog
										dialogTitle="Liste erstellen"
										isCreateList={true}
									/>
								</div>
							</div>
						</Grid> */}
					</Grid>

					<ShoppingList appContextState={appContextState} />
				</Box>
			</Container>
		</>
	)
}
export default ShoppingListPage
